var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    on: {
      click: _vm.clickFun
    }
  }, [_c("div", {
    staticClass: "navBox",
    style: "color:" + _vm.styleObj.titleColor
  }, [_vm._v(_vm._s(_vm.$t("页面标题")))]), _vm.pageDescription && _vm.pageDescriptionConfig.position == "top" && _vm.pageDescriptionConfig.content ? _c("div", {
    staticStyle: {
      position: "relative",
      padding: "10px",
      background: "#fff"
    }
  }, [_c("div", {
    staticClass: "page-content",
    style: {
      background: _vm.styleObj.themeColor
    }
  }), _c("span", {
    staticClass: "page-font-content",
    style: {
      color: _vm.styleObj.themeColor
    }
  }, [_vm._v(_vm._s(_vm.pageDescriptionConfig.content))])]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };